import { useTranslation } from 'react-i18next';
import { Breakpoint, Typography, Button } from 'app/component-library-wave';
import { ContainerFixed } from 'app/components/container';
import { ContainerLayoutMode } from 'app/components/container/container';
import { useAppNavigation } from 'app/utils/navigation-utils';
import { getAnonymizedCurrentPageUrl, getGtmFullUrl, GtmElementCta } from 'app/utils/gtm-tracking-utils';
import { getDataLayers } from 'app/utils/trackingService';

import styles from './hjem-app.module.scss';

export const HJEM_APP_URL = getGtmFullUrl('/hjem');

export const HjemApp = () => {
  const { t } = useTranslation();
  const { goToPath } = useAppNavigation();

  const appleStoreUrl = 'https://apps.apple.com/no/app/altibox-hjem/id6465989392';
  const googlePlayUrl = 'https://play.google.com/store/apps/details?id=no.altibox.hjemmenett&hl=no&pli=1';

  const handleClick = (platform: string, url: string) => {
    getDataLayers().customEvents.pushButtonClickEvent({
      page_url: getAnonymizedCurrentPageUrl(),
      element_cta: `${GtmElementCta.HJEM_APP_DOWNLOAD}}-${platform}`,
      element_url: url,
    });
  };

  return (
    <ContainerFixed mode={ContainerLayoutMode.Medium} className={styles.pageContainer}>
      <Typography
        component="h2"
        variant="formds-common-header-tertiary"
        bold={true}
        maxBreakpoint={Breakpoint.TABLET}
        className={styles.headingText}
      >
        {t('pages.hjemApp.name')}
      </Typography>
      <Typography component="p" variant="uiText1" className={styles.paragraph}>
        {t('pages.hjemApp.paragraph1')}
      </Typography>
      <div className={styles.badgesContainer}>
        <a
          className={styles.badgeContainer}
          href={appleStoreUrl}
          onClick={() => handleClick('ios', appleStoreUrl)}
          target="_blank"
          rel="noopener"
        >
          <img
            src={'/minesider/images/app-store.png'}
            alt={t('pages.hjemApp.ctaApple')}
            className={styles.badgeImageApple}
          />
        </a>
        <a
          className={styles.badgeContainer}
          href={googlePlayUrl}
          onClick={() => handleClick('android', googlePlayUrl)}
          target="_blank"
          rel="noopener"
        >
          <img
            src={'/minesider/images/google-play.png'}
            alt={t('pages.hjemApp.ctaGoogle')}
            className={styles.badgeImageGoogle}
          />
        </a>
      </div>
      <img src={'/minesider/images/hjem-app-hero.png'} alt={''} className={styles.hjemAppHero} />
      <Typography component="p" variant="uiText1" className={styles.paragraph}>
        {t('pages.hjemApp.paragraph2')}
      </Typography>
      <Typography component="p" variant="uiText1" className={styles.paragraph}>
        {t('pages.hjemApp.paragraph3')}
      </Typography>
      <Button
        className={styles.ctaButton}
        role="link"
        onClick={() => goToPath('https://www.altibox.no/hjem')}
        tabIndex={0}
      >
        {t('pages.hjemApp.ctaMoreInfo')}
      </Button>
    </ContainerFixed>
  );
};
